module.exports = __webpack_public_path__ + "img/Z60_09.bf3bf3a9.jpg";